<div class="bg-tertiary p-2 border-start border-warning border-5 mt-4 mb-3 d-flex align-items-center justify-content-between">
  <h3 class="fw-bold fs-6 mb-0">Logs data</h3>
</div>

<div class="row justify-content-start py-3">
  @for (column of columns; track column) {
    <div class="col-3">
      @for (index of column; track index) {
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [id]="index" [(ngModel)]="data[index]" [ngModelOptions]="{standalone: true}">
          <label class="form-check-label small fw-bold" [for]="index">{{ ('columnData.' + index) | translate }}</label>
        </div>
      }
    </div>
  }
</div>
